export default __webpack_public_path__ + "5aa2f382eb186965d0d01427f2b1c608.svg";